import termsAndConditions from "./TermsAndConditions";
import '../../styles/common.scss';

export default function TermsAndConditionsContainer() {
    
    const termsData = termsAndConditions.data[0].attributes;
    
    return (
      <div className='hygiene_wrapper'>
        <p className='title'>
          {termsData?.pageTemplates[0]?.heading}
        </p>
  
        <p className='description'>
          {termsData?.pageTemplates[0]?.description}
        </p>
  
        <div className='content'>
          {termsData?.pageTemplates[0]?.sections?.map((item, index) => (
            <div className='content' key={"terms_" + index}>
              <p className='subtitle'>
                {item?.title}
              </p>
              <p className='description'>
                {item?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }